import React from 'react';
import FestivalForm from './FestivalForm';
import { connect } from 'react-redux';
import { festivalActions } from 'redux/actions/festival-action';
import {
  Grid,
  Row,
  Col
} from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";

class EditFestivalPage extends React.Component {
	constructor(props){
		super(props);

		const { id } = this.props.match.params;

		this.state = {
			festivalId : id,
			adminType : this.props.adminType
		};
		this.handleAction = this.handleAction.bind(this);
	};
	handleAction(festivalData){

		this.props.editFestivalCall(this.state.festivalId, festivalData);
	};
	componentDidMount () {

	    this.props.getFestivalCall(this.state.festivalId);
  	}

	render(){
		const { editFestival } = this.props;
		const { adminType } = this.state;
		return(

			<div className="content">
	        	<Grid fluid>
	          		<Row>
	            		<Col md={12}>
	              			<Card
				                title={adminType === 'company'?'Edit Festival':'Festival'}
				                content={
				                	<div>
			                            <Grid fluid>
			                                <Row>
			                                	<Col md={12}>
			                                		{
														editFestival && <FestivalForm 
															handleActionParent={this.handleAction}  
															festivalDataFP={editFestival} 
															adminTypeData={adminType} 
															formType = "edit"
														/>
													}
			                                	</Col>
			                                </Row>
			                            </Grid>
			                        </div>
				                }
				            />
	             		</Col>
	            	</Row>
	          	</Grid>
	        </div>
			
		);
	};
}

const mapDispatchToProps = dispatch => {
  return ({
    getFestivalCall  : (id) => { dispatch(festivalActions.getFestival(id)) },
    editFestivalCall : (id,festivalData) => { dispatch(festivalActions.editFestival(id, festivalData)) }
  });
};

function mapStateToProps(state) {
    const { loading, editFestival } = state.festivalReducer;
    const { adminType } = state.adminReducer;
    return {
        loading, editFestival, adminType
    };
}

const EditFestival = connect(mapStateToProps, mapDispatchToProps)(EditFestivalPage);
export default EditFestival;


// WEBPACK FOOTER //
// ./src/components/Admin/Festival/EditFestival.jsx